import { Layout } from "antd";
import "./index.css";
import constants from "./constants/constants";
import { useAuth } from "./globalFunctions/AuthContext";
const { Footer } = Layout;
const Footers = () => {
	const { beVersion  } = useAuth();
	return (
		<div className="">
			<Footer className="text-center slp-footer d-flex justify-between">
				<span></span>
				{" "}
				{constants.footerText}
				<p className="text-right font-x-small mb-0">{constants.feBuild} | {beVersion}</p>
			</Footer>
		</div>
	);
};
export default Footers;
